import React, { PropsWithChildren } from "react";
import { Grid } from "@material-ui/core";

export const CbTemplateLayoutRight = (props: PropsWithChildren<any>) => (
  <Grid item xs={12} md={4}>
    {props.children}
  </Grid>
);
